export default {
  order: 4,
  name: "Handover Requests",
  icon: "file_copy",
  to: "/handover/handOverRequests",
};
